import React, { useState, useRef } from 'react';
import { FiPlus, FiTrash2, FiEdit2, FiSave, FiChevronLeft, FiChevronRight, FiX, FiCheckCircle, FiMenu, FiX as FiClose } from 'react-icons/fi';
import styles from './Adpduld.module.css'; 
import AdmVertNav from '../../admincomponents/AdminVertNav/AdmVertNav';
import config from '../../config/config';
const AddProducts = () => {
  // Form state
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
 
  const [productName, setProductName] = useState('');
  const [productDetails, setProductDetails] = useState('');
  const [benefits, setBenefits] = useState('');
  const [weightValue, setWeightValue] = useState('');
  const [weightUnit, setWeightUnit] = useState('');
  const [priceNPR, setPriceNPR] = useState('');
  const [priceINR, setPriceINR] = useState('');
  const [priceUSD, setPriceUSD] = useState('');
  const [images, setImages] = useState([]);
  const [currentImage, setCurrentImage] = useState(0);
  const [tags, setTags] = useState([]);
  const [tagInput, setTagInput] = useState('');
  const [showCategories, setShowCategories] = useState(false);
  const [categories, setCategories] = useState([
    { name: 'Top selling Products', selected: false, isEditing: false },
    { name: 'Karnali Special', selected: false, isEditing: false },
    { name: 'Karnali Organic', selected: false, isEditing: false },
    { name: 'Our Products', selected: false, isEditing: false },
    { name: 'Supplements', selected: false, isEditing: false },
  ]);
  const [newCategoryName, setNewCategoryName] = useState('');
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  
  const formRef = useRef(null);

  const validateForm = () => {
    const newErrors = {};
    
    if (!productName.trim()) newErrors.productName = 'Product name is required';
    if (!productDetails.trim()) newErrors.productDetails = 'Product details are required';
    if (!benefits.trim()) newErrors.benefits = 'Benefits are required';
    if (!weightValue) newErrors.weightValue = 'Weight value is required';
    if (!weightUnit) newErrors.weightUnit = 'Weight unit is required';
    if (!priceNPR) newErrors.priceNPR = 'NPR price is required';
    if (!priceINR) newErrors.priceINR = 'INR price is required';
    if (!priceUSD) newErrors.priceUSD = 'USD price is required';
    if (images.length === 0) newErrors.images = 'At least one image is required';
    if (tags.length === 0) newErrors.tags = 'At least one tag is required';
    
    // Check if at least one category is selected
    const hasSelectedCategory = categories.some(cat => cat.selected);
    if (!hasSelectedCategory) newErrors.categories = 'At least one category must be selected';
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    setImages(prev => [...prev, ...files]);
    setErrors(prev => ({ ...prev, images: undefined }));
  };

  const handleNext = () => {
    setCurrentImage((prev) => (prev + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentImage((prev) => (prev - 1 + images.length) % images.length);
  };

  const handleDelete = () => {
    if (images.length > 0) {
      const updatedImages = [...images];
      updatedImages.splice(currentImage, 1);
      setImages(updatedImages);
      setCurrentImage(Math.min(currentImage, updatedImages.length - 1));
      if (updatedImages.length === 0) {
        setErrors(prev => ({ ...prev, images: 'At least one image is required' }));
      }
    }
  };

  const toggleCategory = (index) => {
    const updated = [...categories];
    updated[index].selected = !updated[index].selected;
    setCategories(updated);
    setErrors(prev => ({ ...prev, categories: undefined }));
  };

  const addNewCategory = () => {
    if (newCategoryName.trim() !== '') {
      const updated = [...categories, { name: newCategoryName.trim(), selected: false, isEditing: false }];
      setCategories(updated);
      setNewCategoryName('');
    }
  };

  const deleteCategory = (index) => {
    const updated = [...categories];
    updated.splice(index, 1);
    setCategories(updated);
  };

  const editCategory = (index) => {
    const updated = [...categories];
    updated[index].isEditing = true;
    setCategories(updated);
  };

  const saveCategory = (index) => {
    const updated = [...categories];
    updated[index].isEditing = false;
    setCategories(updated);
  };

  const handleCategoryNameChange = (index, newName) => {
    const updated = [...categories];
    updated[index].name = newName;
    setCategories(updated);
  };

  const resetForm = () => {
    setProductName('');
    setProductDetails('');
    setBenefits('');
    setWeightValue('');
    setWeightUnit('');
    setPriceNPR('');
    setPriceINR('');
    setPriceUSD('');
    setImages([]);
    setTags([]);
    setCategories(categories.map(cat => ({ ...cat, selected: false })));
    setErrors({});
    formRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const postProduct = async () => {
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const formData = new FormData();
      formData.append('productName', productName);
      formData.append('productDetails', productDetails);
      formData.append('benefits', benefits);
      formData.append('weightValue', weightValue);
      formData.append('weightUnit', weightUnit);
      formData.append('tags', JSON.stringify(tags)); 

      const priceData = {
        npr: priceNPR,
        inr: priceINR,
        usd: priceUSD,
      };
      
      formData.append('pdprice', JSON.stringify(priceData));
      
      const selectedCategories = categories.filter(cat => cat.selected).map(cat => cat.name);
      formData.append('categories', JSON.stringify(selectedCategories));

      images.forEach((image) => {
        formData.append('images', image); 
      });
      
      const response = await fetch(`${config.apiBaseUrl}/api/products/add`, {
        method: 'POST',
        body: formData,
      });
  
      const data = await response.json();
      
      if (response.ok) {
        setSuccessMessage(`Product "${productName}" added successfully!`);
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 5000);
        resetForm();
      } else {
        throw new Error(data.message || 'Failed to upload product');
      }
    } catch (error) {
      setSuccessMessage(`Error: ${error.message}`);
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 5000);
    } finally {
      setIsSubmitting(false);
    }
  };
const handleAddTag = () => {
  if (tagInput.trim() !== '') {
    setTags([...tags, tagInput.trim()]);
    setTagInput('');
    setErrors(prev => ({ ...prev, tags: undefined }));
  }
};
  return (
    <div className={styles.adminContainer}>
      {/* Mobile Navigation Toggle */}
      <button 
        className={styles.mobileNavToggle}
        onClick={() => setMobileNavOpen(!mobileNavOpen)}
      >
        {mobileNavOpen ? <FiClose size={24} /> : <FiMenu size={24} />}
      </button>

      {/* Vertical Navigation */}
      <AdmVertNav 
        mobileNavOpen={mobileNavOpen} 
        closeMobileNav={() => setMobileNavOpen(false)} 
        
      />

      <div className={styles.addProductsContainer} ref={formRef}>
        {/* Success Notification */}
        {showSuccess && (
          <div className={styles.successNotification}>
            <FiCheckCircle className={styles.successIcon} />
            <span>{successMessage}</span>
            <button 
              className={styles.closeNotification}
              onClick={() => setShowSuccess(false)}
            >
              <FiX size={18} />
            </button>
          </div>
        )}

        <div className={styles.header}>
          <h1 className={styles.title}>Add New Product</h1>
          <p className={styles.subtitle}>All fields are required</p>
        </div>

        <div className={styles.addProductsWrapper}>
          {/* Form Section */}
          <div className={styles.formSection}>
            <div className={styles.card}>
              <h3 className={styles.cardTitle}>Product Information</h3>
              
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Product Name *</label>
                <input 
                  type="text" 
                  className={`${styles.formInput} ${errors.productName ? styles.errorInput : ''}`}
                  value={productName}
                  onChange={(e) => {
                    setProductName(e.target.value);
                    setErrors(prev => ({ ...prev, productName: undefined }));
                  }}
                  placeholder="Enter product name"
                />
                {errors.productName && <span className={styles.errorMessage}>{errors.productName}</span>}
              </div>

              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Product Details *</label>
                <textarea 
                  className={`${styles.formTextarea} ${errors.productDetails ? styles.errorInput : ''}`}
                  value={productDetails}
                  onChange={(e) => {
                    setProductDetails(e.target.value);
                    setErrors(prev => ({ ...prev, productDetails: undefined }));
                  }}
                  placeholder="Describe the product specifications also use this '|' symbol for line seperation"
                  rows="4"
                />
                {errors.productDetails && <span className={styles.errorMessage}>{errors.productDetails}</span>}
              </div>

              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Benefits *</label>
                <textarea 
                  className={`${styles.formTextarea} ${errors.benefits ? styles.errorInput : ''}`}
                  value={benefits}
                  onChange={(e) => {
                    setBenefits(e.target.value);
                    setErrors(prev => ({ ...prev, benefits: undefined }));
                  }}
                  placeholder="List the benefits of using this product"
                  rows="4"
                />
                {errors.benefits && <span className={styles.errorMessage}>{errors.benefits}</span>}
              </div>

              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Product Weight *</label>
                <div className={styles.weightInputGroup}>
                  <input
                    type="number"
                    className={`${styles.formInput} ${errors.weightValue ? styles.errorInput : ''}`}
                    placeholder="e.g. 500"
                    value={weightValue}
                    onChange={(e) => {
                      setWeightValue(e.target.value);
                      setErrors(prev => ({ ...prev, weightValue: undefined }));
                    }}
                  />
                  <select 
                    className={`${styles.weightSelect} ${errors.weightUnit ? styles.errorInput : ''}`}
                    value={weightUnit} 
                    onChange={(e) => {
                      setWeightUnit(e.target.value);
                      setErrors(prev => ({ ...prev, weightUnit: undefined }));
                    }}
                  >
                    <option value="">Select unit *</option>
                    <option value="g">g</option>
                    <option value="kg">kg</option>
                    <option value="ml">ml</option>
                    <option value="l">l</option>
                    <option value="pcs">pcs</option>
                  </select>
                </div>
                {(errors.weightValue || errors.weightUnit) && (
                  <span className={styles.errorMessage}>
                    {errors.weightValue || errors.weightUnit}
                  </span>
                )}
              </div>

              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Tags *</label>
                <div className={styles.tagsContainer}>
  <div className={styles.inputWithButton}>
    <input
      type="text"
      className={`${styles.formInput} ${errors.tags ? styles.errorInput : ''}`}
      placeholder="Enter tag and press Enter or tap Add"
      value={tagInput}
      onChange={(e) => setTagInput(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleAddTag();
        }
      }}
    />
    <button
      type="button"
      className={styles.addTagButton}
      onClick={handleAddTag}
    >
      Add
    </button>
  </div>

  <div className={styles.tagsList}>
    {tags.map((tag, index) => (
      <span key={index} className={styles.tag}>
        {tag}
        <button
          type="button"
          className={styles.tagRemove}
          onClick={() => {
            setTags(tags.filter((_, i) => i !== index));
            if (tags.length === 1) {
              setErrors(prev => ({ ...prev, tags: 'At least one tag is required' }));
            }
          }}
        >
          <FiX size={14} />
        </button>
      </span>
    ))}
  </div>
  {errors.tags && <span className={styles.errorMessage}>{errors.tags}</span>}
</div>

              </div>
            </div>

            <div className={styles.card}>
              <h3 className={styles.cardTitle}>Pricing *</h3>
              
              <div className={styles.priceGrid}>
                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>Price in Nepal (NPR)</label>
                  <div className={styles.priceInputWrapper}>
                    <span className={styles.currencySymbol}>NPR</span>
                    <input 
                      type="number"
                      className={`${styles.formInput} ${errors.priceNPR ? styles.errorInput : ''}`}
                      value={priceNPR}
                      onChange={(e) => {
                        setPriceNPR(e.target.value);
                        setErrors(prev => ({ ...prev, priceNPR: undefined }));
                      }}
                      placeholder="0.00"
                    />
                  </div>
                  {errors.priceNPR && <span className={styles.errorMessage}>{errors.priceNPR}</span>}
                </div>

                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>Price in India (INR)</label>
                  <div className={styles.priceInputWrapper}>
                    <span className={styles.currencySymbol}>₹</span>
                    <input 
                      type="number"
                      className={`${styles.formInput} ${errors.priceINR ? styles.errorInput : ''}`}
                      value={priceINR}
                      onChange={(e) => {
                        setPriceINR(e.target.value);
                        setErrors(prev => ({ ...prev, priceINR: undefined }));
                      }}
                      placeholder="0.00"
                    />
                  </div>
                  {errors.priceINR && <span className={styles.errorMessage}>{errors.priceINR}</span>}
                </div>

                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>Price in USA (USD)</label>
                  <div className={styles.priceInputWrapper}>
                    <span className={styles.currencySymbol}>$</span>
                    <input 
                      type="number"
                      className={`${styles.formInput} ${errors.priceUSD ? styles.errorInput : ''}`}
                      value={priceUSD}
                      onChange={(e) => {
                        setPriceUSD(e.target.value);
                        setErrors(prev => ({ ...prev, priceUSD: undefined }));
                      }}
                      placeholder="0.00"
                    />
                  </div>
                  {errors.priceUSD && <span className={styles.errorMessage}>{errors.priceUSD}</span>}
                </div>
              </div>
            </div>

            <div className={styles.card}>
              <h3 className={styles.cardTitle}>Images *</h3>
              
              <div className={`${styles.imageUploadArea} ${errors.images ? styles.errorBorder : ''}`}>
                {images.length > 0 ? (
                  <div className={styles.imagePreview}>
                    <img src={URL.createObjectURL(images[currentImage])} alt="Product preview" />
                  </div>
                ) : (
                  <div className={styles.uploadPlaceholder}>
                    <FiPlus size={48} className={styles.uploadIcon} />
                    <p>Upload product images</p>
                  </div>
                )}
                
                <input 
                  type="file" 
                  id="fileUpload" 
                  onChange={handleImageUpload}
                  multiple 
                  accept="image/*"
                  className={styles.fileInput}
                />
                <label htmlFor="fileUpload" className={styles.uploadButton}>
                  <FiPlus size={18} /> Select Images
                </label>
              </div>
              {errors.images && <span className={styles.errorMessage}>{errors.images}</span>}
            </div>
          </div>

          {/* Sidebar Section */}
          <div className={styles.sidebarSection}>
            <div className={styles.card}>
              <h3 className={styles.cardTitle}>Categories *</h3>
              
              <button 
                className={styles.toggleCategoriesButton}
                onClick={() => setShowCategories(!showCategories)}
              >
                {showCategories ? 'Hide Categories' : 'Manage Categories'}
              </button>

              {errors.categories && <span className={styles.errorMessage}>{errors.categories}</span>}

              {showCategories && (
                <div className={styles.categoriesPanel}>
                  <div className={styles.categoriesList}>
                    {categories.map((cat, index) => (
                      <div key={index} className={styles.categoryItem}>
                        <div className={styles.categoryCheckbox}>
                          <input 
                            type="checkbox" 
                            id={`cat-${index}`}
                            checked={cat.selected} 
                            onChange={() => toggleCategory(index)}
                          />
                          <label htmlFor={`cat-${index}`}>
                            {cat.isEditing ? (
                              <input
                                type="text"
                                className={styles.categoryEditInput}
                                value={cat.name}
                                onChange={(e) => handleCategoryNameChange(index, e.target.value)}
                              />
                            ) : (
                              cat.name
                            )}
                          </label>
                        </div>
                        
                        <div className={styles.categoryActions}>
                          {cat.isEditing ? (
                            <button 
                              className={styles.categoryActionButton}
                              onClick={() => saveCategory(index)}
                            >
                              <FiSave size={16} />
                            </button>
                          ) : (
                            <button 
                              className={styles.categoryActionButton}
                              onClick={() => editCategory(index)}
                            >
                              <FiEdit2 size={16} />
                            </button>
                          )}
                          <button 
                            className={`${styles.categoryActionButton} ${styles.deleteButton}`}
                            onClick={() => deleteCategory(index)}
                          >
                            <FiTrash2 size={16} />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className={styles.addCategoryForm}>
                    <input 
                      type="text" 
                      className={styles.formInput}
                      placeholder="New category name" 
                      value={newCategoryName}
                      onChange={(e) => setNewCategoryName(e.target.value)}
                    />
                    <button 
                      className={styles.addCategoryButton}
                      onClick={addNewCategory}
                    >
                      <FiPlus size={18} /> Add Category
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className={styles.card}>
              <h3 className={styles.cardTitle}>Image Preview</h3>
              
              <div className={styles.imageViewer}>
                {images.length > 0 ? (
                  <img src={URL.createObjectURL(images[currentImage])} alt="Product preview" />
                ) : (
                  <div className={styles.noImagePlaceholder}>
                    <p>No images selected</p>
                  </div>
                )}
              </div>

              {images.length > 0 && (
                <div className={styles.imageControls}>
                  <div className={styles.imageNavigation}>
                    <button 
                      className={styles.navButton}
                      onClick={handlePrev}
                      disabled={images.length <= 1}
                    >
                      <FiChevronLeft size={20} />
                    </button>
                    <span className={styles.imageCounter}>
                      {currentImage + 1} / {images.length}
                    </span>
                    <button 
                      className={styles.navButton}
                      onClick={handleNext}
                      disabled={images.length <= 1}
                    >
                      <FiChevronRight size={20} />
                    </button>
                  </div>
                  
                  <button 
                    className={styles.deleteImageButton}
                    onClick={handleDelete}
                    disabled={images.length === 0}
                  >
                    <FiTrash2 size={16} /> Delete Current
                  </button>
                </div>
              )}
            </div>

            <button 
              className={styles.submitButton}
              onClick={postProduct}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Publishing...' : 'Publish Product'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddProducts;
